import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { GroupOfUser } from '@rocksoft/security-sdk';

export function selectUserIdFromParent(group: GroupOfUser) {
  return group.userId ? `${group.userId}-${group.id}` : group.id;
}
export const adapter: EntityAdapter<GroupOfUser> = createEntityAdapter<GroupOfUser>({
  selectId: selectUserIdFromParent,
});

export type UserGroupState = EntityState<GroupOfUser>;

export const initialstate: UserGroupState = adapter.getInitialState();
